export {VscodeFormLabel} from './vscode-form-label.js';
